/**
 * Student Dashboard
 * Landing page for users with the "Student" role.
 * Currently surfaces the Enrollment Verification self-service card.
 * Designed to be responsive so it works on mobile as well as desktop.
 */

import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '../auth/LoginButton';

export function StudentDashboard() {
  const navigate = useNavigate();
  const user = getCurrentUser();

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {/* Page header */}
      <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <h2 style={{
          margin: '0 0 0.4rem',
          fontSize: '26px',
          fontWeight: '700',
          color: 'var(--accent)',
        }}>
          Student Portal
        </h2>
        <p style={{ margin: 0, fontSize: '14px', color: 'var(--text-secondary)' }}>
          Welcome back, {user?.name ?? 'Student'}. Use the options below to manage your
          student records and documents.
        </p>
      </div>

      {/* Card grid — add more cards here as student features are built out */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '1.5rem',
        width: '100%',
      }}>
        {/* ── Enrollment Verification card ── */}
        <div
          role="button"
          tabIndex={0}
          aria-label="Request Enrollment Verification"
          onClick={() => navigate('/EnrollmentVerification')}
          onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && navigate('/EnrollmentVerification')}
          style={{
            background: 'var(--card-bg)',
            border: '1px solid var(--card-border)',
            borderRadius: '16px',
            padding: '40px 36px',
            cursor: 'pointer',
            transition: 'box-shadow 0.2s, transform 0.15s',
            boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
          }}
          onMouseEnter={e => {
            (e.currentTarget as HTMLElement).style.boxShadow = '0 6px 24px rgba(0,0,0,0.22)';
            (e.currentTarget as HTMLElement).style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={e => {
            (e.currentTarget as HTMLElement).style.boxShadow = '0 2px 12px rgba(0,0,0,0.12)';
            (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
          }}
        >
          <div style={{ fontSize: '40px', marginBottom: '14px', textAlign: 'center' }}>📄</div>
          <h3 style={{
            margin: '0 0 8px',
            fontSize: '17px',
            fontWeight: '700',
            color: 'var(--text-primary)',
            textAlign: 'center',
          }}>
            Enrollment Verification
          </h3>
          <p style={{
            margin: 0,
            fontSize: '13px',
            color: 'var(--text-secondary)',
            lineHeight: '1.55',
            textAlign: 'center',
          }}>
            Generate an official enrollment verification letter on Laurus College letterhead.
          </p>
          <div style={{
            marginTop: '18px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '6px',
            fontSize: '13px',
            fontWeight: '600',
            color: 'var(--accent)',
          }}>
            Get document →
          </div>
        </div>
      </div>
    </div>
  );
}
